import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import DatePickerCustom from './DatePickerCustom';
import apiClient from '../../Services/NetteApiClient';
import { format, parseISO } from 'date-fns';

loadDOMComponent({
	selector: 'react-date-picker-custom',
	callback: ({ container }) => {
		const changeUrl = container.getAttribute('onchangeurl');
		const value = container.getAttribute('value');

		const handleChange = date => {
			apiClient.post(changeUrl, {
				date: format(date, 'yyyy-MM-dd'),
			});
		};

		ReactDOM.render(
			<AppContextProvider>
				<DatePickerCustom onChange={handleChange} value={value} />
			</AppContextProvider>,
			container,
		);
	},
});
